import { getAuthState } from "@/store/auth.state";
import { refreshAccessToken } from "@/utils/refreshAccessToken";
import { redirectToLogin } from "@vixi/router";
import { ApiError } from "@vixi/types";
import { logger } from "@vixi/utils";
import axios, {
  AxiosError,
  AxiosResponse,
  HttpStatusCode,
  InternalAxiosRequestConfig,
} from "axios";

export const authRequestInterceptor = async (config: InternalAxiosRequestConfig) => {
  const token = getAuthState().accessToken;

  if (token) {
    config.headers.setAuthorization(`Bearer ${token}`);
  }

  return config;
};

export const authResponseInterceptor = async (response: AxiosResponse) => {
  if (response.status === HttpStatusCode.Unauthorized) {
    await refreshAccessToken()
      .catch(redirectToLogin)
      .then(async (tokenData) => {
        if (!tokenData) return;
        response.config.headers.setAuthorization(`Bearer ${tokenData.accessToken}`);

        logger.debug("DEBUG: Retrying request after refreshing access token");

        response = await axios(response.config).catch((e: AxiosError<ApiError>) => {
          if (e.response?.status === HttpStatusCode.Unauthorized) redirectToLogin();
          throw e;
        });
      });
  }

  return response;
};
